<ul
  class="nav-pills nav-fill nav-signal-generator gap-1"
  ngbNav
  #nav="ngbNav"
  [activeId]="selectedSignalGeneratorType$ | async"
  (navChange)="onNavChange($event)"
>
  @for (signalGenerator of signalGenerators$ | async; track signalGenerator.id) {
    <li [ngbNavItem]="signalGenerator.type">
      <button
        type="button"
        ngbNavLink
        container="body"
        placement="bottom"
        class="w-100 rounded border"
        ngbTooltip="{{ signalGenerator.name }}"
        [openDelay]="450"
        (click)="onSelectSignalGeneratorType(signalGenerator.type)"
      >
        <ng-container
          [ngTemplateOutlet]="generatorShapesSvg"
          [ngTemplateOutletContext]="{ $implicit: signalGenerator.icon }"
        ></ng-container>
      </button>
      <ng-template ngbNavContent>
        <div class="mt-3">
          @if (tuningController.type === 'position') {
            <div>
              <div class="mb-2">
                <div class="row">
                  <div class="col-lg-5">
                    <label for="positionInput" class="col-form-label">Actual Position</label>
                  </div>
                  <div class="col-lg">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        [formControl]="positionFormControl"
                        id="positionInput"
                        readonly
                      />
                      <app-parameter-form-control-input-group-append
                        [parameter]="positionActualParameter$ | async"
                        [showUnit]="true"
                        [showApplyButton]="false"
                        [showHelpButton]="false"
                        [feedConstantEnabled]="feedConstantEnabled$ | async"
                        [feedConstantUnit]="feedConstantUnit$ | async"
                        (unitChange)="onPositionUnitChange($event)"
                        class="d-inline-flex"
                      >
                      </app-parameter-form-control-input-group-append>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <app-parameter-form
            [parameters$]="signalGeneratorParameters(signalGenerator)"
            [preventSubmitOnEnter]="true"
            [showApplyButton]="false"
            [showSubmit]="(operationEnabled$ | async) === false && (quickStopActive$ | async) === false"
            [submitDisabled]="starting || (isMotionPrevented$ | async)"
            submitText="START MOTION"
            [submitTooltip]="motionPreventedMessage$ | async"
            (formSubmit)="onFormSubmit($event)"
            (unitChange)="onAmplitudeUnitChange($event)"
          >
          </app-parameter-form>
          @if (operationEnabled$ | async) {
            <button type="button" class="btn btn-danger fw-bold w-100 mt-2" (click)="onStopSignalGenerator()">
              STOP
            </button>
          }
          @if (quickStopActive$ | async) {
            <button type="button" class="btn btn-secondary w-100 mt-2" (click)="onDisableMotionController()">
              DISABLE CONTROLLER
            </button>
          }
        </div>
      </ng-template>
    </li>
  }
</ul>
<div [ngbNavOutlet]="nav"></div>

<ng-template #generatorShapesSvg let-shape>
  @switch (shape) {
    @case ('stepResponse') {
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1.5em" height="1.5em">
        <path
          fill="currentColor"
          d="M488.173 135.685c-5.31 0.001-10.589 2.186-14.344 5.941s-5.94 9.034-5.941 14.344v644.304h-199.175c-5.31 0.001-10.589 2.186-14.344 5.941s-5.94 9.034-5.941 14.344v47.471c0.001 5.31 2.186 10.589 5.941 14.344s9.034 5.94 14.344 5.941h266.931c5.31-0.001 10.589-2.186 14.344-5.941s5.94-9.034 5.941-14.344v-644.306h199.359c5.31-0.001 10.589-2.186 14.344-5.941s5.94-9.034 5.941-14.344v-47.469c-0.001-5.31-2.186-10.589-5.941-14.344s-9.034-5.94-14.344-5.941z"
        ></path>
      </svg>
    }
    @case ('advancedStepResponse') {
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1.5em" height="1.5em">
        <path
          fill="currentColor"
          d="M169.176 225.213c-7 0.002-14.552 7.555-14.553 14.555v45.464c0.114 0.476 0.182 1.024 0.188 1.587v180.092c-0.001 4.123-3.343 7.465-7.466 7.466h-88.431c-7 0.002-14.552 7.555-14.553 14.555v46.098c0 0 0 0.002 0 0.002 0.002 6.999 7.554 14.551 14.553 14.553 0 0 0.002 0 0.002 0h156.511c7-0.001 14.554-7.554 14.555-14.555v-227.182c0.001-4.123 3.343-7.465 7.466-7.466h122.945c4.123 0.001 7.465 3.343 7.466 7.466v0 180.276c-0.011 0.485-0.067 0.951-0.163 1.402l0.009-0.049v45.554c0.001 7 7.554 14.554 14.555 14.555h191.212c4.123 0.001 7.465 3.343 7.466 7.466v0 227.182c0 0 0 0.002 0 0.002 0.002 6.999 7.554 14.551 14.553 14.553 0 0 0.002 0 0.002 0h259.179c7-0.001 14.554-7.554 14.555-14.555v-227.182c0.001-4.123 3.343-7.465 7.466-7.466h88.395c7-0.001 14.552-7.553 14.555-14.553v-46.099c-0.001-7-7.554-14.554-14.555-14.555h-156.511c-7 0.001-14.553 7.553-14.555 14.553v227.184c-0.001 4.123-3.343 7.465-7.466 7.466h-122.945c-4.123-0.001-7.465-3.343-7.466-7.466v0-227.182c0 0 0-0.002 0-0.002-0.002-6.999-7.554-14.551-14.553-14.553h-191.063c-4.123-0.001-7.465-3.343-7.466-7.466v0-227.143c-0.001-7-7.554-14.554-14.555-14.555h-259.329z"
        ></path>
      </svg>
    }
    @case ('ramp') {
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1.5em" height="1.5em">
        <path
          fill="currentColor"
          d="M628.353 135.333c-9.264 0-17.79 5.792-21.202 14.405l-257.053 649.095h-157.095c-6.027 0-11.861 2.413-16.124 6.676s-6.679 10.097-6.68 16.124v44.233c0.001 6.028 2.417 11.861 6.68 16.124s10.097 6.678 16.124 6.678h202.67c9.265 0 17.79-5.793 21.202-14.407l257.029-649.093h157.095c6.028-0.001 11.86-2.418 16.122-6.68s6.679-10.094 6.68-16.122v-44.233c-0.001-6.027-2.417-11.86-6.68-16.122s-10.095-6.677-16.122-6.678z"
        ></path>
      </svg>
    }
    @case ('trapezoidal') {
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1.5em" height="1.5em">
        <path
          fill="currentColor"
          d="M380.473 236.723c-8.483 0.001-17.525 6.146-20.649 14.033l-180.161 454.97c-1.311 3.248-4.438 5.498-8.090 5.499h-102.441c-5.705 0-11.67 2.471-15.704 6.504s-6.506 10.001-6.506 15.706v31.633c0 5.705 2.473 11.672 6.506 15.706s9.999 6.504 15.704 6.504h144.957c8.483-0.001 17.525-6.146 20.649-14.033l180.144-454.97c1.311-3.248 4.438-5.498 8.090-5.499h203.177c3.804 0 7.039 2.442 8.221 5.844l0.018 0.061 153.916 453.525c2.832 8.342 12.222 15.071 21.032 15.071h145.529c5.705 0 11.672-2.473 15.706-6.506s6.504-9.999 6.504-15.704v-31.633c0-5.705-2.471-11.672-6.504-15.706s-10.001-6.504-15.706-6.504h-100.703c-3.804 0-7.039-2.442-8.221-5.844l-0.018-0.061-153.914-453.525c-2.832-8.342-12.222-15.071-21.032-15.071z"
        ></path>
      </svg>
    }
    @case ('bidirectional') {
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1.5em" height="1.5em">
        <path
          fill="currentColor"
          d="M287.706 158.581c-19.417 9.227-15.008-4.745-21.257 15.616l-111.314 355.151h-86.995c-11.665 0.001-22.278 10.614-22.279 22.279v34.857c0.001 11.665 10.614 22.278 22.279 22.279h128.968c0 0 0.001 0 0.001 0s0.001 0 0.001 0v0c9.409-0.001 18.44-6.636 21.255-15.614 0.001-0.001 0.002-0.002 0.002-0.002v0l111.314-355.149h171.629l141.241 610.164c0 0 0 0.001 0 0.001s0 0.001 0 0.001v0c2.25 9.719 11.73 17.254 21.706 17.254h200.626c9.234-0.001 18.128-6.372 21.097-15.116l91.153-268.489c3.75-11.048-2.891-24.513-13.939-28.262 0 0-0.001 0-0.001 0s-0.001 0-0.001 0v0l-33.003-11.193c-11.046-3.745-24.503 2.893-28.253 13.937 0 0 0 0.001 0 0.001s0 0.001 0 0.001v0l-77.964 229.703h-114.299l-141.241-610.164c0 0 0-0.001 0-0.001s0-0.001 0-0.001v0c-2.25-9.719-11.73-17.254-21.706-17.254h-259.019c0 0-0.001 0-0.001 0s-0.001 0-0.001 0v0z"
        ></path>
      </svg>
    }
    @case ('squareWave') {
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1.5em" height="1.5em">
        <path
          fill="currentColor"
          d="M149.406 146.535c-11.593 0.002-22.141 10.551-22.143 22.145v608.926c0 5.401-4.378 9.779-9.779 9.779h-62.897c-11.593 0.002-22.141 10.551-22.143 22.145v45.793c0.002 11.593 10.55 22.14 22.143 22.143h137.785c11.593-0.002 22.141-10.551 22.143-22.145v-608.979c0-5.401 4.378-9.779 9.779-9.779h135.043c5.401 0 9.779 4.378 9.779 9.779v0 562.939c-0.015 0.202-0.033 0.368-0.054 0.533l0.005-0.049v45.555c0.001 11.594 10.55 22.143 22.145 22.145h241.652c11.593-0.002 22.141-10.551 22.143-22.145v-608.979c0-5.401 4.378-9.779 9.779-9.779h135.043c5.401 0 9.779 4.378 9.779 9.779v0 608.979c0.001 11.594 10.55 22.143 22.145 22.145h137.656c11.593-0.002 22.141-10.551 22.143-22.145v-45.793c-0.002-11.593-10.55-22.14-22.143-22.143h-62.77c-5.401 0-9.779-4.378-9.779-9.779v0-608.928c-0.002-11.593-10.55-22.14-22.143-22.143h-284.82c-11.593 0.002-22.14 10.55-22.143 22.143v608.928c0 5.401-4.378 9.779-9.779 9.779h-91.879c-5.401 0-9.779-4.378-9.779-9.779v0-608.926c-0.001-11.594-10.549-22.142-22.143-22.145h-284.768z"
        ></path>
      </svg>
    }
    @case ('sineWave') {
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1.5em" height="1.5em">
        <path
          fill="currentColor"
          d="M318.479 148.015c-19.792-0.069-39.219 3.923-57.512 11.82-0.001 0.001-0.001 0.001-0.002 0.002v0c-43.774 18.887-79.565 58.687-109.448 116.603-29.885 57.921-54.365 134.714-74.834 231.794-1.129 5.358-0.045 11.148 2.944 15.736s7.847 7.917 13.205 9.049l35.336 7.456c5.36 1.131 11.152 0.047 15.741-2.944s7.919-7.852 9.049-13.213c18.426-87.478 40.186-156.225 64.236-205.215 23.849-48.581 49.665-76.557 74.032-87.363l-0.32 0.322c0.267-0.267 0.583-0.486 0.934-0.641l0.020-0.008c0.13-0.058 0.287-0.113 0.449-0.155l0.021-0.005-0.089 0.021c23.778-10.1 49.684-7.019 85.981 15.135 38.478 23.5 59.785 61.862 72.842 111.359 13.065 49.529 16.854 109.008 20.445 168.615 0 0.001 0 0.001 0 0.002s0 0.001 0 0.002v0c0 0.003 0 0.005 0 0.008s0.001 0.015 0.002 0.027v0.008c3.865 64.001 7.598 130.368 25.34 189.223 17.73 58.815 51.372 111.244 112.414 139.198 30.212 13.836 60.014 21.133 88.919 21.133 25.448 0 50.139-5.789 72.954-17.118 0 0 0.001 0 0.001 0s0.001 0 0.001 0v0c83.184-41.249 137.677-147.664 176.121-318.911 1.199-5.343 0.191-11.146-2.738-15.772s-7.744-8.019-13.086-9.22l-35.222-7.912c-5.344-1.2-11.149-0.193-15.776 2.737s-8.019 7.747-9.22 13.090c-17.182 76.525-38.295 136.72-61.344 180.963-23.048 44.241-47.991 72.63-73.358 85.208-0.001 0.001-0.003 0.001-0.004 0.002 0.015-0.007 0.012-0.005 0.010-0.004l-0.018 0.008c-26.926 13.361-55.72 12.794-94.771-5.085-0.001 0-0.001 0-0.002 0s0-0.001 0-0.001 0-0.001 0-0.001v0c-38.484-17.628-58.909-49.989-71.907-96.121-13.018-46.199-16.804-104.766-20.509-166.173 0 0 0-0.001 0-0.001s0-0.001 0-0.001v0-0.002c-3.877-64.23-7.681-130.795-24.629-191.187-16.938-60.36-48.221-115.426-105.863-150.611-33.663-20.549-67.343-31.743-100.343-31.858z"
        ></path>
      </svg>
    }
    @default {}
  }
</ng-template>
